import {
    postFilesDriverLoading,
    postFilesDriverRequest,
    postFilesDriverSuccess,
    postFilesDriverReject,
    postFilesDriverReset
} from "../../actions/filesDriver/post";

export const postFilesDriver = (formData) => async (dispatch, getState) => {
    dispatch(postFilesDriverLoading());
    try {
        const { data } = await postFilesDriverRequest(formData, getState);
        dispatch(postFilesDriverSuccess(data))
    } catch (error) {
        dispatch(postFilesDriverReject(error))
    } finally {
        setTimeout(() => { dispatch(postFilesDriverReset()) }, 3000);
    }
    return Promise.resolve();
};